// Style
import '../../styles/responsivephone/phone_main.scss'
import '../../styles/responsivephone/phone_projects.scss'

// Components
import ErrorPhone from '../../components/error/error_phone_version'
import PhoneHeader from '../../components/phoneresponsive/phone_header'
import FolderWindow from '../../components/main/folderwindow'
import Modal from '../../components/main/modal'
import PhoneFooter from '../../components/phoneresponsive/phone_footer'

// Basic
import { useState } from 'react'
import { useFetch } from '../../hooks/fetch'

// Language
import { useLanguage } from '../../context/language_context'
import { translate } from '../../utils/translate'


function PersoProjects() {

    // ========================================
    // LANGUAGE
    // ========================================

    const { language } = useLanguage()


    // ========================================
    // DATA
    // ========================================

    const { data, error } = useFetch(
        `/db/projects.json?v=${Date.now()}`
    )


    // ========================================
    // CURRENT FOLDER
    // ========================================

    const [currentFolder, setCurrentFolder] = useState(null)
    const [path, setPath] = useState([])


    // ========================================
    // PROJECT MODAL
    // ========================================

    const [selectedProject, setSelectedProject] = useState(null)


    const openProject = (project) => {
        setSelectedProject(project)
    }


    const closeProject = () => {
        setSelectedProject(null)
    }


    // ========================================
    // FOLDER NAVIGATION
    // ========================================

    const openFolder = (folder, newPath) => {

        setCurrentFolder(folder)
        setPath(newPath)

    }


    // ========================================
    // LOADING / ERROR
    // ========================================

    if (!data) {
        return (
            <span>
                {language === 'fr'
                    ? 'Chargement en cours...'
                    : 'Loading...'}
            </span>
        )
    }


    if (error) {
        return (
            <span>
                {language === 'fr'
                    ? 'Il y a un problème'
                    : 'Something went wrong'}
            </span>
        )
    }


    // ========================================
    // ROOT FOLDER
    // ========================================

    const rootFolder = {
        id: 'projects',
        name: {
            fr: 'Projets',
            en: 'Projects'
        },
        type: 'folder',
        children: data
    }


    const displayedFolder = currentFolder || rootFolder


    // ========================================
    // RENDER
    // ========================================

    return (

        <div className="phone_projects">

            <ErrorPhone />

            <PhoneHeader />


            <p className="phone_projects_title">

                {language === 'fr'
                    ? 'Mes projets'
                    : 'My projects'}

            </p>


            <FolderWindow
                folder={displayedFolder}
                path={path}
                onOpenFolder={openFolder}
                onOpenProject={openProject}
                isRoot={true}
            />


            {selectedProject && (

                <Modal
                    closeModal={closeProject}

                    name={translate(
                        selectedProject.name,
                        language
                    )}

                    description={translate(
                        selectedProject.description,
                        language
                    )}

                    projectstate={translate(
                        selectedProject.projectstate,
                        language
                    )}

                    objectives={translate(
                        selectedProject.objectives,
                        language
                    )}

                    langages={translate(
                        selectedProject.langages,
                        language
                    )}

                    creationdate={translate(
                        selectedProject.creationdate,
                        language
                    )}

                    github={selectedProject.github}
                    images={selectedProject.images}
                />

            )}


            <PhoneFooter />

        </div>

    )
}


export default PersoProjects